import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ChevronRight, X } from 'lucide-react'

interface AnnouncementBarProps {
  id: string
  text: string
  ctaLabel?: string
  to?: string
}

const dismissKey = (id: string) => `zy:announcement-dismissed:${id}`

const AnnouncementBar: React.FC<AnnouncementBarProps> = ({ id, text, ctaLabel = 'See what changed', to = '/changelog' }) => {
  const navigate = useNavigate()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      if (localStorage.getItem(dismissKey(id)) !== '1') {
        setVisible(true)
      }
    } catch {
      setVisible(true)
    }
  }, [id])

  if (!visible) return null

  const dismiss = () => {
    try {
      localStorage.setItem(dismissKey(id), '1')
    } catch {
      // ignore storage failures, bar just won't persist dismissal
    }
    setVisible(false)
  }

  return (
    <div className="relative z-20 flex items-center justify-center gap-3 border-b border-zypheron-500/20 bg-zypheron-500/10 px-4 py-2 text-center text-xs font-mono-tech uppercase tracking-[0.14em] text-zypheron-200">
      <button onClick={() => navigate(to)} className="inline-flex items-center gap-1.5 hover:text-white transition-colors">
        {text}
        <ChevronRight className="h-3 w-3" />
        <span className="normal-case tracking-normal text-zypheron-400">{ctaLabel}</span>
      </button>
      <button onClick={dismiss} aria-label="Dismiss announcement" className="absolute right-4 text-zypheron-400 hover:text-white transition-colors">
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  )
}

export default AnnouncementBar
